export const TABLET_SCREEN_WIDTH = 728;
export const SMALL_SCREEN_WIDTH = 530;

export enum SCREEN_MODES {
  MOBILE = "MOBILE",
  TABLET = "TABLET",
  DESKTOP = "DESKTOP",
}
